<template lang="pug">
  .lesson-block.main-block
    .lesson-block__content
      p.main-block__label.answers-card__label
        | Вопрос:

      .lesson-block__markdown.form-item__markdown(
        v-if="contentLocal.description"
        v-html="makeHtml(contentLocal.description)"
      )

      .lesson-block__row
        p.main-block__label.answers-card__label
          | Ответ:

      .lesson-block__row.lesson-block-franch-answer
        Input.lesson-block__edit.-no-grow-(
          v-if="!taskIsAnswered"
          :style="{width: '30%'}"
          v-model="contentLocal.answer.answerText"
          title=""
          placeholder="Ответ на вопрос"
          :error="$v.$dirty && !$v.contentLocal.answer.answerText.required"
        )
        Input.lesson-block__edit.-no-grow-(
          v-else
          :style="{width: '30%'}"
          :disabled="true"
          :value="contentLocal.answer.answerText"
          title=""
        )
        .lesson-block-franch-validating(
          v-if="taskIsAnswered"
          :class="`${contentLocal.answer.isCorrect ? '-correct-' : '-incorrect-'}`"
        )
          | {{contentLocal.answer.validatingText}}

      .lesson-block__buttons(
        v-if="!taskIsAnswered"
      )
        Button.-xs-(
          @click="sendAnswer"
          :isLoading="isLoading"
        )
          | Отправить
    slot
</template>

<script>
import _ from 'lodash';
import markdownToHtml from '@/functions/converterMarkdownToHtml';
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    content: {},
    block: {}
  },
  data() {
    return {
      contentLocal: {
        answer: {
          answerText: ''
        }
      },
      isLoading: false
    };
  },
  computed: {
    taskIsAnswered() {
      return this.contentLocal.answer.isCorrect !== undefined;
    }
  },
  watch: {
    content() {
      this.setData();
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.contentLocal = _.cloneDeep(this.content);
    },
    makeHtml(value) {
      return markdownToHtml.makeHtml(value);
    },
    async sendAnswer() {
      if (this.isLoading) {
        return;
      }

      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      this.isLoading = true;
      const res = await this.$store.dispatch('coursesLesson/sendT5V2', {
        blockId: this.block.id,
        answer: this.contentLocal.answer.answerText
      });

      if (res.numbers) {
        this.contentLocal.answer = { ...res };
        await this.$store.dispatch('lms/setMenuData', {
          path: 'numbers',
          value: res.numbers
        });
      }
      this.isLoading = false;
    }
  },
  validations: {
    contentLocal: {
      answer: {
        answerText: { required }
      }
    }
  }
};
</script>
